import { ApplicationEntity } from "@/model/entity/application-entity"
import { ShipmentParcelShop } from "./shipment-parcel-shop"
import { ShipmentSender } from "./shipment-sender"
import { ShipmentReceiver } from "./shipment-receiver"
import { ShipmentDeskDelivery } from "./shipment-desk-delivery"
import { ShipmentIdCheck } from "./shipment-id-check"
import { ShipmentOptions } from "./shipment-options"
import { ShipmentCOD } from "./shipment-cod"
import {Type} from "class-transformer"

export class Shipment extends ApplicationEntity {
  @Type(() => ShipmentParcelShop)
  shipmentParcelShop?: ShipmentParcelShop
  shipmentSender?: ShipmentSender
  shipmentReceiver?: ShipmentReceiver
  shipmentDeskDelivery?: ShipmentDeskDelivery
  shipmentIdCheck?: ShipmentIdCheck
  shipmentOptions?: ShipmentOptions
  shipmentCOD?: ShipmentCOD
  numberOfParcels: number
  shipmentReference: string
  shipmentSource: string
  parentShipment?: Shipment

  constructor(
    numberOfParcels: number,
    shipmentReference: string,
    shipmentSource: string,
    shipmentParcelShop?: ShipmentParcelShop,
    shipmentSender?: ShipmentSender,
    shipmentReceiver?: ShipmentReceiver,
    shipmentDeskDelivery?: ShipmentDeskDelivery,
    shipmentIdCheck?: ShipmentIdCheck,
    shipmentOptions?: ShipmentOptions,
    shipmentCOD?: ShipmentCOD,
    id?: number
  ) {
    super(id)
    this.numberOfParcels = numberOfParcels
    this.shipmentReference = shipmentReference
    this.shipmentParcelShop = shipmentParcelShop
    this.shipmentSender = shipmentSender
    this.shipmentReceiver = shipmentReceiver
    this.shipmentDeskDelivery = shipmentDeskDelivery
    this.shipmentIdCheck = shipmentIdCheck
    this.shipmentOptions = shipmentOptions
    this.shipmentCOD = shipmentCOD
    this.shipmentSource = shipmentSource
  }
}
